/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul[_ngcontent-%COMP%]{list-style-type:disc;padding-left:16px}div[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:16px;font-weight:400;line-height:1.5}button[_ngcontent-%COMP%]{position:absolute;top:0;right:0;color:#fff;background-color:rgba(0,0,0,0)}.pzl-margin-top[_ngcontent-%COMP%]{margin-top:18px}"];
export { styles as styles };
